import { TIER_ORDER } from "./constants";

import type { CarrierTier } from "../types";

// Mixed and Unknown sit outside the strategic hierarchy, so they take the
// weakest rank: they trail every ranked tier when the column is sorted
// descending, and lead them when it is sorted ascending.
const UNRANKED_TIER_STRENGTH = 0;

// TIER_ORDER lists the hierarchy strongest-first, so strength counts down from
// its length: Tier 1 is 3, Tier 2 is 2, Non-Strategic is 1.
const tierStrength = (tier: CarrierTier): number => {
  const position = TIER_ORDER.indexOf(tier);
  return position === -1
    ? UNRANKED_TIER_STRENGTH
    : TIER_ORDER.length - position;
};

// AG Grid sorts on the sign of its column comparator, and its default one
// compares the tier labels as strings — which ranks Non-Strategic above Tier 1.
// Comparing strength instead makes descending read Tier 1 → Tier 2 →
// Non-Strategic, and ascending the reverse.
const compareCarrierTier = (a: CarrierTier, b: CarrierTier): number =>
  tierStrength(a) - tierStrength(b);

export { compareCarrierTier };
